import { environmentDev } from './environment.dev';
import { environmentProd } from './environment.prod';
import { environmentMX } from './environment.prod-mx';
import { environmentQa } from './environment.qa';

export interface PlanItemDescription {
  text: string;
  icon: string;
  referencePlanText?: string;
  referencePlanColor?: string;
  iconColor?: string;
}
export interface PlanConditions {
  friendlyName: string;
  includes: PlanItemDescription[];
  price: PlanItemDescription[];
}
export interface PublicationPlans {
  [key: string]: PlanConditions;
}

export interface Environment {
  referAndWinUrl: string;
  segmentAnalyticsApiKey: string;
  decimalSeparator: string;
  groupSeparator: string;
  thousandSeparator: string;
  urlLogin: string;
  hotjarHJID: number;
  hotjarHJSV: number;
  sentryDNS: string;
  plans: PublicationPlans;
  chatBotAgentId: string;
  gcpStorage: {
    baseUrl: string;
    cdnBaseUrl: string;
  };
  capturingAgent: {
    bucketUploadDocument: string;
  };
  gtmId: string;
}

const COUNTRY_ENVS = {
  CO: environmentProd,
  MX: environmentMX,
};

const COUNTRY_CODE = process.env.NEXT_PUBLIC_COUNTRY_CODE || 'CO';

function getEnvironment(): Environment {
  switch (process.env.NODE_ENV) {
    case 'production':
      return COUNTRY_ENVS[COUNTRY_CODE];
    case 'test':
      return environmentQa;
    default:
      return environmentDev;
  }
}

export const environment: Environment = getEnvironment();
